import { BaseBookingModel } from '@xeetr/types/models'

export const InfoColumn = (booking: BaseBookingModel) =>
  booking.bookingAdditions?.additionalInfo ?? ''
